import { render } from "./ModelAddPeriod.vue?vue&type=template&id=2ae4f436&scoped=true"
import script from "./ModelAddPeriod.vue?vue&type=script&lang=js"
export * from "./ModelAddPeriod.vue?vue&type=script&lang=js"

import "./ModelAddPeriod.vue?vue&type=style&index=0&id=2ae4f436&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae4f436"]])

export default __exports__